import { useEffect, useMemo } from 'react';
import get from 'lodash/get';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { useCountrySelect } from '../../../../hocs/useCountrySelect';

import { selectCountryList } from '../../../../redux/data/selectors';
import {
  selectAppointmentFormUserCountry,
  selectAppointmentFormUserState,
} from '../../../../redux/appointmentForm/selectors';

const useAppointmentVisitDetailsStateData = () => {
  const { formatMessage } = useIntl();

  const country = useSelector(selectAppointmentFormUserCountry);

  const state = useSelector(selectAppointmentFormUserState);

  const countryList = useSelector(selectCountryList);

  const { loadCountryDetails, stateList } = useCountrySelect(formatMessage);

  const targetCountry = countryList.find(({ name }) => name === country);

  const targetCountryEntity = useMemo(() => {
    if (!targetCountry) return null;

    return { label: targetCountry.name, value: targetCountry.isoCode };
  }, [targetCountry]);

  const stateOptions = useMemo(
    () =>
      stateList.map(option => ({
        value: option.label,
        label: option.label,
      })),
    [stateList],
  );

  useEffect(() => {
    const countryValue = get(targetCountryEntity, 'value', null);

    if (countryValue) {
      loadCountryDetails(countryValue);
    }
  }, [targetCountryEntity]);

  return {
    initCountryFormValue: get(targetCountryEntity, 'label', null),
    state,
    stateList,
    stateOptions,
  };
};

export default useAppointmentVisitDetailsStateData;



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentVisitDetails/hooks/useAppointmentVisitDetailsStateData.js